import type { TOC } from '@ember/component/template-only';
import { PrismIconBrand } from '@mylighthouse/prism-ember';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import { t } from 'ember-intl';
import parityColorStyles from 'lumen/components/parity/parity-colors.module.css';
import type { BaseRate as FullBaseRate } from 'lumen/utils/parity-utils';

import styles from './table-pos-tooltip.module.css';

type BaseRate = Pick<
  FullBaseRate,
  'channel' | 'extractDatetimeFromNow' | 'rateUnconverted' | 'source'
>;

type FormattedChannel = {
  extractDatetimeFromNow: string;
  loss: string | null;
  rateUnconverted: string;
  source: string;
  title: string;
};

function getFirstBaseRate(baseRates: BaseRate[]): BaseRate | undefined {
  return baseRates[0];
}

interface ParityTooltipsTooltipPosTableLossSignature {
  Args: {
    baseRates: BaseRate[];
    formattedChannels: FormattedChannel[];
  };
}

const ParityTooltipsTooltipPosTableLoss = <template>
  <EmberTooltip
    @delay={{25}}
    @side="bottom"
    @tooltipClass="base-tooltip {{styles.table-pos-tooltip}}"
  >
    <table cellspacing="0">
      <thead>
        <tr>
          <th>
            {{t "parity.channel"}}
          </th>
          <th>
            {{t "parity.lowest_rate"}}
          </th>
          <th>
            {{t "parity.loss"}}
          </th>
          <th>
            {{t "parity.source"}}
          </th>
          <th>
            {{t "general.updated"}}
          </th>
        </tr>
      </thead>

      <tbody>
        {{#each @formattedChannels as |channel|}}
          <tr>
            <td>
              {{channel.title}}
            </td>
            <td>
              {{channel.rateUnconverted}}
            </td>
            <td class={{parityColorStyles.loss}}>
              {{channel.loss}}
            </td>
            <td>
              {{channel.source}}
            </td>
            <td>
              {{channel.extractDatetimeFromNow}}
            </td>
          </tr>
        {{/each}}

        <tr>
          <td>
            <div class="flex items-center gap-100">
              {{#each @baseRates as |baseRate|}}
                <PrismIconBrand @name={{baseRate.channel}} />
              {{/each}}
            </div>
          </td>
          {{#let (getFirstBaseRate @baseRates) as |firstBaseRate|}}
            <td>
              {{firstBaseRate.rateUnconverted}}
            </td>
            <td></td>
            <td>
              {{firstBaseRate.source}}
            </td>
            <td>
              {{firstBaseRate.extractDatetimeFromNow}}
            </td>
          {{/let}}
        </tr>
      </tbody>
    </table>
  </EmberTooltip>
</template> satisfies TOC<ParityTooltipsTooltipPosTableLossSignature>;

export default ParityTooltipsTooltipPosTableLoss;
